// src/pages/RagCollectionsPage.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ragListCollections, ragCreateCollection } from "../api/client";
import "../styles/rag.css";
import "../styles/base.css";

// Embedding models to choose from
const EMBEDDING_OPTIONS = [
  { value: "nomic-embed-text", label: "nomic-embed-text (local/Ollama)" },
  {
    value: "text-embedding-3-small",
    label: "text-embedding-3-small (OpenAI)",
  },
  { value: "bge-m3", label: "bge-m3" },
];

export default function RagCollectionsPage() {
  const [collections, setCollections] = useState([]);
  const [form, setForm] = useState({
    projectId: "",
    name: "",
    description: "",
    slug: "",
    llmProvider: "ollama",
    llmModel: "llama3.1:8b",
    embedModel: "nomic-embed-text",
    chunkSize: "1000",
    overlap: "200",
  });

  const load = async () => {
    // show ALL KBs (no project filter for listing)
    const data = await ragListCollections();
    setCollections(data);
  };

  useEffect(() => {
    load();
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const onCreate = async (e) => {
    e.preventDefault();

    // Basic validation for project ID
    const projectIdNum = Number(form.projectId);
    if (!form.projectId || Number.isNaN(projectIdNum) || projectIdNum <= 0) {
      alert("Please enter a valid numeric Project ID (integer > 0).");
      return;
    }

    const chunkSizeNum = Number(form.chunkSize) || 1000;
    const overlapNum = Number(form.overlap) || 200;

    await ragCreateCollection({
      project_id: projectIdNum,
      name: form.name,
      description: form.description || undefined,
      slug: form.slug || undefined,
      embedding_model: form.embedModel,
      indexing_options: {
        chunk_size: chunkSizeNum,
        overlap: overlapNum,
        llm_provider: form.llmProvider,
        llm_model: form.llmModel,
        embed_model: form.embedModel,
      },
    });

    setForm((f) => ({
      ...f,
      name: "",
      description: "",
      slug: "",
      // keep projectId so user can create multiple KBs for same project
    }));
    load();
  };

  return (
    

       <div className="rag-page">
      <div className="rag-header">
      <h1>RAG Knowledge Bases</h1>
</div>
      <section className="rag-section">
        <h2>Create Knowledge Base</h2>
        <form className="rag-form" onSubmit={onCreate}>
          <div className="rag-grid">
            <div>
              <label>Project ID (SOW / Project)</label>
              <input
                type="number"
                name="projectId"
                value={form.projectId}
                onChange={onChange}
                placeholder="e.g. 1"
                min={1}
                required
              />
            </div>
            <div>
              <label>KB Name</label>
              <input
                name="name"
                value={form.name}
                onChange={onChange}
                required
              />
            </div>
            <div>
              <label>Slug (optional)</label>
              <input
                name="slug"
                value={form.slug}
                onChange={onChange}
                placeholder="marvell-q1-renewals"
              />
            </div>
          </div>

          <div>
            <label>Description</label>
            <textarea
              name="description"
              rows={2}
              value={form.description}
              onChange={onChange}
              placeholder="Short description of what this KB contains..."
            />
          </div>

          <h3>LLM & Embeddings</h3>
          <div className="rag-grid">
            <div>
              <label>LLM Provider</label>
              <select
                name="llmProvider"
                value={form.llmProvider}
                onChange={onChange}
              >
                <option value="ollama">Ollama (local)</option>
              </select>
            </div>
            <div>
              <label>LLM Model</label>
              <input
                name="llmModel"
                value={form.llmModel}
                onChange={onChange}
                placeholder="llama3.1:8b"
              />
            </div>
            <div>
              <label>Embedding Model</label>
              <select
                name="embedModel"
                value={form.embedModel}
                onChange={onChange}
              >
                {EMBEDDING_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <h3>Indexing (chunking)</h3>
          <div className="rag-grid">
            <div>
              <label>Chunk size (characters)</label>
              <input
                type="number"
                name="chunkSize"
                value={form.chunkSize}
                onChange={onChange}
                min={200}
                max={4000}
              />
            </div>
            <div>
              <label>Overlap (characters)</label>
              <input
                type="number"
                name="overlap"
                value={form.overlap}
                onChange={onChange}
                min={0}
                max={1000}
              />
            </div>
          </div>
                 <div className="rag-tabs">
          <button type="submit">Create KB</button></div>
        </form>
      </section>

      <h2 style={{ marginTop: "1.5rem" }}>Existing KBs</h2>
      <table className="rag-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>KB Name</th>
            <th>Project</th>
            <th>Slug</th>
            <th>LLM / Embed</th>
            <th>RAG URL</th>
            <th>RAG Client Script</th>
          </tr>
        </thead>
        <tbody>
          {collections.map((c) => (
            <tr key={c.id}>
              <td>{c.id}</td>
              <td>
                <Link to={`/rag/kb/${c.id}`}>{c.name}</Link>
              </td>
              <td>{c.project_id ?? "-"}</td>
              <td>{c.slug}</td>
              <td>
                <code>
                  {c.indexing_options?.llm_model || form.llmModel || "llm"}
                </code>
                <br />
                <small>embed: {c.embedding_model}</small>
              </td>
              <td>
                <code>/api/search/collections/{c.id}/ask</code>
              </td>
              <td>
                <Link to={`/rag/kb/${c.id}/scripts`}>Client Scripts</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
